import appBackup from "../../views/appRoutes/backup.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("backup", {
    url: "backup/:id",
    parent: "app",
    views: {
      view: {
        template: appBackup,
      },
    },
    reloadOnSearch: false,
    data: { title: "Backup" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/backup/backup.urls.js